import styled from 'styled-components';
const ScheduledSupersionModalWrapper = styled.div`
.w-50{
    width:50%;
}
.scheduled-supervision{
    >header{
        border-bottom:1px solid rgb(238,240,249);
        text-align:center;
        padding: 10px 0;
        margin: 0 0 10px;
        >h1{
            font-family: 'Open Sans',sans-serif;
            font-size:24px;
            font-weight: bold;
            color: #333e61;
            text-transform: capitalize;
            display: inline-block;
            margin: 0;
            padding: 0 20px 0;
            text-align: center;
        }
    }
    .scheduled-supervision-content{
        >label{
            font-family: 'Open Sans',sans-serif;
            font-size: 18px;
            font-weight: 500;
            color: #344177;
            text-transform: capitalize;
            display: block;
            margin: 0;
            padding: 0;
            line-height: normal;
        }
        .therapist-profile{
            margin-top:5px;
            margin-bottom:10px;
            display: flex;
            align-items:center;
            .initial{
                background:#05b3db;
                width:50px;
                height:50px;
                min-width:50px;
                border-radius:50px;
                text-align:center;
                line-height:50px;
                font-size: 18px;
                font-weight: 600;
                color:#fff;
                display:block;
                margin-right:15px; 
            }
            .therapist-name{
                display:flex;
                flex-direction:column;
                h2{
                font-family: 'Open Sans',sans-serif;
                font-size: 18px;
                font-weight: normal;
                text-transform:capitalize;
                color: #333e7b;
                padding:0;
                white-space:nowrap;
                line-height: normal;
                margin: 0;
                }
                h3{
                    font-family: 'Open Sans',sans-serif;
                    font-size: 18px;
                    font-weight: 700;
                    text-transform:uppercase;
                    color: #00abd8;
                    padding:0;
                    white-space:nowrap;
                    line-height: normal;
                }
            }
            
        }
    }
    ._status{
            margin: 0 0 20px;
            >label{
                font-family: 'Open Sans',sans-serif;
                font-size: 18px;
                font-weight: 500;
                color: #344177;
                text-transform: capitalize;
                display: block;
                margin: 0;
                padding: 0;
                line-height: normal;
            }
            >h4{
                font-family: 'Open Sans',sans-serif;
                font-size: 18px;
                font-weight: 700;
                color: #344177;
                text-transform: capitalize;
                display: block;
                margin: 0;
                padding: 0;
                line-height: normal; 
            }
        }
    .footer-action{
        .join-room-link{
            position: relative;
            background: #00abd8;
            color: white;
            height: 55px;
            border-radius: 4px;
            border-radius: 25px;
            border: 1px solid transparent;
            padding: 0 60px;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 16px;
            cursor: pointer;
            box-sizing: border-box;
            outline: none;
            display: block;
            line-height: 55px;
            text-align: center;
        }
        .dismiss-modal{
            font-family: 'Open Sans',sans-serif;
            font-size: 15px;
            font-weight: 600;
            color: rgb(148,156,192);
            padding: 0;
            white-space: nowrap;
            line-height: normal;
            text-align: center;
            cursor: pointer;
            margin: 20px 0 0;
        }
    }

    .textLabel{
        margin-bottom:10px;
        label{
            font-family: 'Open Sans',sans-serif;
            font-size: 16px;
            font-weight: 500;
            color: #344177;
            text-transform: capitalize;
            display: block;
            margin: 0;
            padding: 0;
            line-height: normal;
        }
    }
    .textBoxPhone{
        font-family: 'Open Sans',sans-serif;
        font-weight:500;
        border:none;
        border-radius:0;
        border-bottom:1px solid rgba(0,0,0,0.1);
        padding-left: 0;
        color:#32407b;
        font-size:17px;
        &:focus{
            outline:none;
            box-shadow:none;
        }
    }

.invite-form-content{
    padding:20px 20px;
    .list-item{
        margin:0 0 20px;
        &.flxbox{
            display:flex;
            justify-content:space-between;
            .col{
                flex-basis:45%;
            }
        }
        .ant-form-item-label{
            display: block;
            width: 100%;
            text-align: left;
        }
        textarea{
            height:125px;
            border:1px solid #4eb0de;
            border-radius:4px;
            resize:none;
        }
    }

}
`;

export default (ScheduledSupersionModalWrapper);